// src/app/shared/services/validation.service.ts (adjust the path as needed)

import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Validation {
  constructor() { }

  noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').toString();

    // Let required validator handle empty values
    if (!value) return null;

    const trimmedValue = value.trim();
    const alphabetOnlyPattern = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

    const isValid =
      value === trimmedValue &&
      !/\s{2,}/.test(value) &&
      alphabetOnlyPattern.test(value);

    return isValid ? null : { whitespaceOrInvalidChars: true };
  }

  passwordComplexityValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';

    if (!value) return null; // Let required validator handle this

    const hasAlphabet = /[A-Za-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    const isValid = hasAlphabet && hasNumber && hasSpecialChar;

    return isValid ? null : { passwordComplexity: true };
  }
}
